export default __webpack_public_path__ + "static/media/iui2023-slides.82fba75a.pdf";